import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
        className={cn(
            // Base State: Standard thin border
            "flex min-h-16 w-full rounded-md border border-border bg-transparent px-3 py-2 text-sm outline-none transition-all duration-200",
            
            // Focus State: Keep border-1 but add a ring to simulate thickness
            "focus-visible:border-foreground focus-visible:ring-[1px] focus-visible:ring-foreground",
            
            // States & Accessibility
            "placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
      {...props}
    />
  )
}

export { Textarea }
